exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".help-link{display:inline-block;vertical-align:middle}.help-link a .vp-icon{color:#c1c1c1}.help-link a .vp-icon:hover{color:#999}", ""]);

// exports
